
import { GenericEntityMetadata, PropertyMetadata, nullIfContainsNull } from '@scisys-uim/uim-common';


export class MechanicalAspectMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('MechanicalAspect', {
      aspectAssetId: <PropertyMetadata> {
        name: 'aspectAssetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      havs: <PropertyMetadata> {
        name: 'havs',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      havsRagStatus: <PropertyMetadata> {
        name: 'havsRagStatus',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      wbv: <PropertyMetadata> {
        name: 'wbv',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      wbvRagStatus: <PropertyMetadata> {
        name: 'wbvRagStatus',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.aspectAssetId;
    return nullIfContainsNull(result);
  }
}



